import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.form`
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 512px;
  padding: 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const Period = styled.p`
  margin: 4px 0 0;
  font-size: 0.72rem;
  color: #8a949c;
`;

export const Question = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
`;

const questionLabel = `
  display: block;
  padding: 0;
  margin-bottom: 6px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const QuestionLabel = styled.legend`
  ${questionLabel}
`;

export const NotesLabel = styled.label`
  ${questionLabel}
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Option = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 0;
  font-size: 0.82rem;
  color: #333;
  cursor: pointer;
`;

/* Radio nativo invisible (mantiene teclado y accesibilidad); el círculo lo pinta RadioMark */
export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin: 0;
`;

export const RadioMark = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid #c5ced6;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  input:checked + & { border-color: #1b5f6e; }
  input:checked + &::after {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #1b5f6e;
  }
  input:focus-visible + & { box-shadow: 0 0 0 3px rgba(38, 169, 182, 0.35); }
`;

export const MoodIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
  margin-right: -4px;
`;

export const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  min-height: 90px;
  padding: 10px 12px;
  border: 1px solid #c5ced6;
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.85rem;
  color: #222;
  outline: none;
  resize: vertical;

  &:focus { border-color: #26A9B6; }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 8px;
`;

export const CancelButton = styled.button`
  padding: 8px 22px;
  border-radius: 7px;
  border: 1.5px solid #79BEE6;
  background: #fff;
  color: #79BEE6;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover { background: #f0f8fd; }
`;

export const SaveButton = styled.button`
  padding: 8px 26px;
  border-radius: 7px;
  border: none;
  background: #79BEE6;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #37a2e0; }
  &:disabled { background: #d9d9d9; cursor: not-allowed; }
`;
